import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ViewMode = 'board' | 'list';
type TableCardsViewMode = 'table' | 'cards';
type DocumentsViewMode = 'list' | 'grid';
export type ActivitySortOrder = 'asc' | 'desc';

interface UiState {
  sidebarOpen: boolean;
  selectedTenantId: string | null;
  issuesViewMode: ViewMode;
  projectsViewMode: ViewMode;
  myProjectsViewMode: TableCardsViewMode;
  testPlansViewMode: ViewMode;
  tasksViewMode: TableCardsViewMode;
  documentsViewMode: DocumentsViewMode;
  projectIssuesViewMode: ViewMode;
  activitySortOrder: ActivitySortOrder;
  issueDetailSidebarOpen: boolean;
  projectDetailSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setSelectedTenantId: (tenantId: string | null) => void;
  setIssuesViewMode: (mode: ViewMode) => void;
  setProjectsViewMode: (mode: ViewMode) => void;
  setMyProjectsViewMode: (mode: TableCardsViewMode) => void;
  setTestPlansViewMode: (mode: ViewMode) => void;
  setTasksViewMode: (mode: TableCardsViewMode) => void;
  setDocumentsViewMode: (mode: DocumentsViewMode) => void;
  setProjectIssuesViewMode: (mode: ViewMode) => void;
  setActivitySortOrder: (order: ActivitySortOrder) => void;
  setIssueDetailSidebarOpen: (open: boolean) => void;
  toggleIssueDetailSidebar: () => void;
  setProjectDetailSidebarOpen: (open: boolean) => void;
  toggleProjectDetailSidebar: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      selectedTenantId: null,
      issuesViewMode: 'board',
      projectsViewMode: 'board',
      myProjectsViewMode: 'table',
      testPlansViewMode: 'board',
      tasksViewMode: 'table',
      documentsViewMode: 'list',
      projectIssuesViewMode: 'list',
      activitySortOrder: 'asc',
      issueDetailSidebarOpen: true,
      projectDetailSidebarOpen: true,

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),

      setSelectedTenantId: (selectedTenantId) => set({ selectedTenantId }),

      setIssuesViewMode: (issuesViewMode) => set({ issuesViewMode }),

      setProjectsViewMode: (projectsViewMode) => set({ projectsViewMode }),

      setMyProjectsViewMode: (myProjectsViewMode) => set({ myProjectsViewMode }),

      setTestPlansViewMode: (testPlansViewMode) => set({ testPlansViewMode }),

      setTasksViewMode: (tasksViewMode) => set({ tasksViewMode }),

      setDocumentsViewMode: (documentsViewMode) => set({ documentsViewMode }),

      setProjectIssuesViewMode: (projectIssuesViewMode) => set({ projectIssuesViewMode }),

      setActivitySortOrder: (activitySortOrder) => set({ activitySortOrder }),

      setIssueDetailSidebarOpen: (issueDetailSidebarOpen) => set({ issueDetailSidebarOpen }),

      toggleIssueDetailSidebar: () =>
        set((state) => ({ issueDetailSidebarOpen: !state.issueDetailSidebarOpen })),

      setProjectDetailSidebarOpen: (projectDetailSidebarOpen) => set({ projectDetailSidebarOpen }),

      toggleProjectDetailSidebar: () =>
        set((state) => ({ projectDetailSidebarOpen: !state.projectDetailSidebarOpen })),
    }),
    {
      name: 'pregoo-ui-storage',
      partialize: (state) => ({
        selectedTenantId: state.selectedTenantId,
        issuesViewMode: state.issuesViewMode,
        projectsViewMode: state.projectsViewMode,
        myProjectsViewMode: state.myProjectsViewMode,
        testPlansViewMode: state.testPlansViewMode,
        tasksViewMode: state.tasksViewMode,
        documentsViewMode: state.documentsViewMode,
        projectIssuesViewMode: state.projectIssuesViewMode,
        activitySortOrder: state.activitySortOrder,
        issueDetailSidebarOpen: state.issueDetailSidebarOpen,
        projectDetailSidebarOpen: state.projectDetailSidebarOpen,
      }),
    },
  ),
);
